import Banner from '../components/banner'
import AboutSection from '../components/aboutSection'
import ContactMeCallToAction from '../components/contactMeCallToAction'

const HomePage = (props) => {
  return (
    <>
      <Banner />
      <AboutSection />
      <ContactMeCallToAction />
    </>
  )
}

export default HomePage
